module.exports = __webpack_public_path__ + "img/courier-gls.9809ef63.svg";